import { Modal } from "antd";
import PersonalForm from "../Personals/PersonalForm";

const PersonalModal = ({ isOpen, onClose, personId, person }) => {
  const mode = personId ? "update" : "add";

  return (
    <Modal
      // title={mode === "add" ? "Add Personnel" : "Update Personnel"}
      open={isOpen}
      onCancel={onClose}
      footer={null}
      destroyOnHidden
      width={900}
    >
      <PersonalForm
        mode={mode}
        person={person}
        onSuccess={onClose}
      />
    </Modal>
  );
};

export default PersonalModal;
